<template>
  <div class="order-list">
    <!-- <PcWorkOrderList
        v-if="false"
      /> -->
    <MWorkOrderList />
  </div>
</template>

<script type="text/ecmascript-6">
// import PcWorkOrderList from "./pc/WorkOrderList.vue";
import MWorkOrderList from "./m/WorkOrderList.vue";

export default {
  data() {
    return {
      tableData: [],
      searchForm: {},
    };
  },
  components: {
    // PcWorkOrderList,
    MWorkOrderList,
  },
  methods: {
    onSubmit() {},
    goDetail(data) {
      console.log(data);
      this.$router.push({
        name: "WorkOrderDetail",
      });
    },
  },
};
</script>

<style scoped lang="scss">
.order-list {
  height: 100%;
}
</style>
